import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAVBzUd6hWoqg86leHgJPbV3AjxQO5DzDs",
  authDomain: "snaptube-dbeae.firebaseapp.com",
  projectId: "snaptube-dbeae",
  storageBucket: "snaptube-dbeae.firebasestorage.app",
  messagingSenderId: "82573404107",
  appId: "1:82573404107:web:8508debec5b5740286f84e",
};

const app = initializeApp(firebaseConfig);
console.log(app.options.projectId);

export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;